import crypto from 'crypto';

export const PASSWORD_MIN_LENGTH:number = 8;
export const PASSWORD_MAX_LENGTH:number = 24;
export const FIRST_NAME_MAX_LENGTH:number = 50;
export const LAST_NAME_MAX_LENGTH:number = 50;
export const EMAIL_MAX_LENGTH:number = 100;
export const EMAIL_MIN_LENGTH:number = 6;

/**
 * Generate a random that matches the password requirements for our okta tenant
 * To match the new requirements of a password we need one uppercase, one lowercase,
 * one number and one symbol. Then we add a bunch of random noise of 20 characters long.
 * should be 80 bits of entropy which should be plenty for online
 * @param length
 */
export const randomPasswordThatMeetsPasswordRequirements = () => {
  const randomLength = 20;

  return '.1Ab' + crypto.randomBytes(Math.ceil(randomLength / 2)).toString('hex').slice(0, randomLength);
};
